import styled from 'styled-components';

export const Th = styled.th`
  text-align: center;
  font-size: 16px;
  color: #000;
  font-weight: 600;
  border: 1px solid #e4e4e4;
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
`;

export const TextButton = styled.button`
  background-color: transparent !important;
  color: ${props => (props.isDisabled ? '#888' : '#4b286d')};
  border: 0;
  cursor: pointer;
  font-weight: 500;
  text-decoration: underline;

  &: hover {
    color: #4b286d;
  }
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const NaviagationButtons = styled.button`
  background-color: #fff;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  cursor: default;
  color: #4b286d;
  font-weight: 500;
  align-item: center;

  &: hover {
    background-color: #f7f7f8 !important;
  }
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const EditContainer = styled.div`
  padding: 1rem;
  border: 1px solid #e3e3e3;
  background: #f2eff4;
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
`;

export const EditInput = styled.input`
  height: 52px !important;
  width: 20% !important;
`;

export const DeleteMessage = styled.p`
  font-weight: 500;
`;

export const AddContainer = styled.div`
  // margin-bottom: 1rem;
`;

export const AddingMain = styled.div`
  padding: 1.25rem;
  border: 1px solid #4b286d;
  background: #f2eff4;
  border-radius: 1rem;
`;

export const AddActions = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 1rem;
  align-items: end;
`;

export const AddHeading = styled.p`
  margin-left: 5px;
  margin-bottom: 1rem;
  font-weight: 600;
`;

export const AddInput = styled.input`
  height: 52px !important;
`;

export const TopBarContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: end;
`;
